// extracted by mini-css-extract-plugin
export var drawerContent = "_2w-0";
export var valueBlock = "_2w-1";
export var valueBlockFrom = "_2w-2 _2w-1";
export var valueBlockTo = "_2w-3 _2w-1";